/** `quickFilterParentGroupId` that every Zeta Category level folds under; used only to resolve the ZC pill's active section. */
export const ZETA_CATEGORY_PILL_ID = 'zetaCategory';

/** `quickFilterParentGroupId` that size and width facets fold under; used for contextual Size Drawer-title behavior. */
export const SIZE_PILL_ID = 'size';

/** Size drawer titles for a multi-gender grouped response, keyed by Department i.e. ZC1FACET value. */
export const SIZE_DRAWER_TITLE_BY_DEPARTMENT: Readonly<Record<string, string>> = {
  clothing: 'Clothing Size', // Clothing serves no width facets.
  shoes: 'Shoe Size & Width'
};
